import React from 'react';
import { useTranslation } from '../context/TranslationContext';
import './TokenExpiredModal.css';

interface TokenExpiredModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLogin: () => void;
}

const TokenExpiredModal: React.FC<TokenExpiredModalProps> = ({ isOpen, onClose, onLogin }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="token-expired-modal-overlay">
      <div className="token-expired-modal">
        <div className="token-expired-icon">⚠️</div>
        <h3>{t('common.session_expired')}</h3>
        <p>{t('common.session_expired_message')}</p>
        <div className="token-expired-buttons">
          <button 
            className="token-expired-login-btn"
            onClick={onLogin}
          >
            {t('common.login')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TokenExpiredModal;
